import React from "react";
import { TableCell, Typography, Box, TableContainer, Table, TableHead, TableRow, TableBody, Paper, } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { BusinessOwnerLayout } from "frontend/src/pages/layouts";
import { useTimetables } from "frontend/src/domain/timetables";
import { playTodayTimetableAttempted } from "frontend/src/features/play-todays-timetable";
import { TableRowsSkeleton } from "frontend/src/ui/table-skeleton";
import { setPlayerTrackQueue } from "frontend/src/domain/player-track-queue";
import { Timetable } from "./timetable-row";
import { useCreateNewTimetable } from "./model";
var Timetables = function () {
    var _a, _b, _c;
    var timetables = useTimetables();
    if (((_a = timetables.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return (React.createElement(Box, { p: 2, component: Paper },
            React.createElement(Typography, null, "\u041F\u043E\u043A\u0430 \u0447\u0442\u043E \u043D\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0438 \u043E\u0434\u043D\u043E\u0439 \u0441\u0435\u0442\u043A\u0438 \u0432\u0435\u0449\u0430\u043D\u0438\u044F.")));
    }
    var play = function (_a) {
        var _b;
        var selected = _a.selected, index = _a.index;
        if (selected) {
            return setPlayerTrackQueue([]);
        }
        var timetable = (_b = timetables.data) === null || _b === void 0 ? void 0 : _b[index];
        if (!timetable) {
            return;
        }
        var id = timetable.id, title = timetable.title;
        playTodayTimetableAttempted({ id: id, title: title });
    };
    return (React.createElement(TableContainer, { component: Paper },
        React.createElement(Table, null,
            React.createElement(TableHead, null,
                React.createElement(TableRow, null,
                    React.createElement(TableCell, { width: "35%" }, "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435"),
                    React.createElement(TableCell, { width: "20%" }, "\u0414\u043D\u0438"),
                    React.createElement(TableCell, { width: "20%" }, "\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0431\u043E\u0442\u044B"),
                    React.createElement(TableCell, { width: "15%" }),
                    React.createElement(TableCell, { width: "5%" }),
                    React.createElement(TableCell, { width: "5%" }))),
            React.createElement(TableBody, null, (_c = (_b = timetables.data) === null || _b === void 0 ? void 0 : _b.map(function (_a, index) {
                var id = _a.id, title = _a.title, scheduleDays = _a.scheduleDays, scheduleTime = _a.scheduleTime, usedBy = _a.usedBy;
                return (React.createElement(Timetable, { key: id, id: id, title: title, scheduleDays: scheduleDays, scheduleTime: scheduleTime, index: index, onPlay: play, usedBy: usedBy }));
            })) !== null && _c !== void 0 ? _c : React.createElement(TableRowsSkeleton, { rows: 10, columns: 6 })))));
};
var Page = function () {
    var _a = useCreateNewTimetable(), createTimetable = _a.createTimetable, isLoading = _a.isLoading;
    return (React.createElement(Box, null,
        React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(ButtonLoader, { color: "primary", variant: "contained", startIcon: React.createElement(Add, { fontSize: "small" }), isLoading: isLoading, onClick: createTimetable }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C")),
        React.createElement(Box, { mt: 2 },
            React.createElement(Timetables, null))));
};
export var TimetablesPage = function () { return (React.createElement(BusinessOwnerLayout, null,
    React.createElement(Page, null))); };
